const t=t=>e=>e.test(t);export{t as testValueType};
